// extracted by mini-css-extract-plugin
export default {"modal":"B41CZcCTFTPdr9x7g97x","content":"esgJJI5XuuTSN2iJ0YvX","title":"ACminRdqZ4SimaYAywXd","icon":"uovYnSfZZgXFvKG9l4R9","computeIcon":"s_cOXeewnQkWOzsF7Oms"};